// extracted by mini-css-extract-plugin
export default {"button":"buttonStyle_button__SUpEF"};